/* eslint-disable no-console */
import { SET_USER_DATA, LOGOUT } from '../types';
import store from '../../../../store';

const objUserData = data => ({
  roles: data.user.roles,
  emails: data.user.emails,
  firstName: data.user.profile.firstName,
  lastName: data.user.profile.lastName,
  isChaseAcademy: data.isChaseAcademy,
  organisations: data.user.profile.organisations,
  bundles: data.bundles || [],
  bundle: data.bundle,
  bundleName:
    data.bundles &&
    data.bundles.filter(bundle => bundle._id === data.bundle)[0].name,
  isAdmin: data.user.roles && data.user.roles.includes('admin'),
  token: data.token,
  userId: data.user._id,
  email: data.user.emails && data.user.emails[0].address,
});

const setUserData = data => ({
  type: SET_USER_DATA,
  user: objUserData(data),
});

const token = () => {
  const state = store.getState();
  const { token } = state.loginReducer;
  if (token) return token;
  return null;
};

const removeLoginParams = () => dispatch => {
  dispatch({ type: LOGOUT });
};

const logout = () => dispatch => {
  dispatch(removeLoginParams());
};

export { removeLoginParams, token, setUserData, logout };
